(function () {
  function initFaq(root) {
    var input = root.querySelector('[data-faq-search]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    var empty = root.querySelector('[data-faq-empty]');
    if (!input || items.length === 0) return;

    function apply() {
      var q = input.value.trim().toLowerCase();
      var anyVisible = false;

      items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        var match = q === '' || text.indexOf(q) !== -1;
        item.hidden = !match;
        if (match) anyVisible = true;
        // While searching, auto-open matches so the answer is visible immediately.
        // When the box is cleared, collapse everything back.
        if (q === '') {
          item.open = false;
        } else {
          item.open = match;
        }
      });

      if (empty) empty.hidden = anyVisible;
    }

    input.addEventListener('input', apply);
    input.addEventListener('search', apply); // fires when the clear (x) is clicked
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq]').forEach(initFaq);
  });
})();
